import { makeAutoObservable } from 'mobx';
import { storageHelper } from '@/utils';
class commonStore {

  pageLoading = false;
  appConfig = {} as any;

  // diningType = 'pickUp';

  diningType = null;
  storeDiningType = null;

  address: any = null;

  constructor() {
    makeAutoObservable(this);
  }

  // interceptLocal = (key: string, value: any) => {
  //   if (key === 'diningType') {
  //     storageHelper.setItem('__dining_type', value);
  //   }
  // }

  updateState = (params: { [key: string]: any }) => {
    for (const [key, value] of Object.entries(params)) {
      // this.interceptLocal(key, value);
      (this as any)[key] = value;
    }

  };

  memberInfo: any = {};
  isLogin = false;
  isOpenLogin = false;

  config = {};
  isLock = false;

  showExpiredTip = null;

}

export default new commonStore();